import { ImageSizes } from '@screens/landing-page-tools/types';
import * as Styles from '@screens/lp-default/components/tools/components/doctor-image/styles';

type doctorImageProps = {
  images: Record<ImageSizes, string>;
};

export default function DoctorImage({ images }: doctorImageProps) {
  return (
    <Styles.DoctorImage data-testid="doctor-image">
      <source media="(min-width: 1320px)" srcSet={`/images/default-landing-page/tools/${images.xl}`} />
      <source
        media="(min-width: 1024px) and (max-width: 1319px)"
        srcSet={`/images/default-landing-page/tools/${images.lg}`}
      />
      <source
        media="(min-width: 664px) and (max-width: 1023px)"
        srcSet={`/images/default-landing-page/tools/${images.md}`}
      />
      <source media="(max-width: 664px)" srcSet={`/images/default-landing-page/tools/${images.sm}`} />
      <img src={`/images/default-landing-page/tools/${images.xl}`} alt="Médico" />
    </Styles.DoctorImage>
  );
}
